import * as React from 'react';
import { styled } from '@mui/material/styles';
import AssignmentIcon from '@mui/icons-material/Assignment';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import PopUp from '../../funtComponents/popUpAnexos';
import Research from '../../funtComponents/research';

import ListReport from '../models/listReport';
import ListAbstract from '../../funtComponents/DistributionFunctions/listAbstract';
import Acordion from '../../funtComponents/DistributionFunctions/acordion';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


export default function DistributionPage() {

  
  const [anexosState] = React.useState("Anexos")
  const [changeOptions] = React.useState("Add")

  return (

    <div
      style={{
        height: '100%',
        display: "flex",
        width: '100%',
        backgroundColor: "#f6f6f6",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div style={{ flexDirection: 'row', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>

        <div style={{ flexDirection: 'row', minWidth: 150, width: '100%', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-start' }}>
          <AssignmentIcon style={{ marginLeft: 10, marginBottom: 10, color: 'rgba(229, 29, 29, 0.7)' }} /><h3 style={{ color: 'rgba(229, 29, 29, 0.7)', alignSelf: 'flex-start', marginLeft: 15, marginBottom: 10, fontSize: 15 }}>
            Distribución
          </h3>
        </div>

        {/* {changeOptions === "Find" ?
          <div style={{ justifyContent: 'center', alignItems: 'center', paddingRight: 10, paddingLeft: 10 }}>
            <Button
              onClick={() => setChangeOp("Add")}
              variant="text"
              style={{ color: 'grey' }}>
              <SearchIcon style={{ width: 30, height: 20, color: 'grey' }} /> Cambiar fecha de filtrado
            </Button>

          </div> :
    null}*/}

        
{changeOptions === "Add" ? <div style={{ paddingLeft: 30, flexDirection: 'row', height: '100%', width: '100%', display: 'flex', flex: 11, alignItems: 'center', justifyContent: 'center' }}>

<PopUp btnText={anexosState}/>

<div style={{ flexDirection: 'row', height: '100%', width: '100%', display: 'flex', flex: 5, alignItems: 'center', justifyContent: 'center' }}>
<Research />
</div>

<div
style={{ display: 'flex', flex: 2, flexDirection: 'row' }}>

{/*  <Button
  onClick={() => setChangeOp("Find")}
  variant="text"
  style={{ color: 'grey' }}>
  <p style={{ fontSize: 10 }}>cancelar</p>
</Button> */}

<Button
  style={{ marginLeft: 10, background: 'rgba(229, 29, 29, 0.7)' }}
  
  variant="contained" color="success" >
  <p style={{ fontSize: 10 }}>filtrar</p>
</Button>
</div>
</div>
:
<div style={{ flexDirection: 'row', height: '100%', width: '100%', display: 'flex', flex: 4, alignItems: 'center', justifyContent: 'center' }} />}

</div>


      <div
        style={{
          height: 'auto',
          display: "flex",
          width: '100%',
          backgroundColor: 'rgba(238, 238, 238, 0.9)',
          marginTop: 10,
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          padding: 10,
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box sx={{ flexGrow: 1, width: '100%', height: '100%', }}>
          <Grid container spacing={2} columns={10}>
            <Grid item xs={5} >
              <Item>
                <ListReport />
              </Item>
            </Grid>
            <Grid item xs={5}>
              <Item>
                <ListAbstract />

              </Item>
            </Grid>
            <Grid item xs={10}>
              <Item>
                <Acordion />

              </Item>
            </Grid>


          </Grid>
        </Box>


      </div>

    </div >
  );
}
